import { gql, type TypedDocumentNode } from '@apollo/client'

export type RecentSearch = {
  id: string
  searchTerm: string
}

export type RecentSearchesResponse = {
  recentSearches: {
    content: RecentSearch[]
  }
}

export type GetRecentSearchesVariables = {
  page: number
  size: number
}

export type AddRecentlySearchedResponse = {
  addRecentlySearched: {
    searchTerm: string
  }
}

export type AddRecentlySearchedVariables = {
  searchTerm: string
}

export type DeleteRecentlySearchedResponse = {
  deleteRecentlySearched: boolean
}

export type DeleteRecentlySearchedVariables = {
  id: string
}

export const FEDERATED_GET_RECENT_SEARCHES: TypedDocumentNode<
  RecentSearchesResponse,
  GetRecentSearchesVariables
> = gql`
  query getRecentSearches($page: Int!, $size: Int!) {
    recentSearches(page: $page, size: $size) {
      content {
        id
        searchTerm
      }
    }
  }
`

export const FEDERATED_ADD_RECENTLY_SEARCHED: TypedDocumentNode<
  AddRecentlySearchedResponse,
  AddRecentlySearchedVariables
> = gql`
  mutation addRecentlySearched($searchTerm: String!) {
    addRecentlySearched(searchTerm: $searchTerm) {
      searchTerm
    }
  }
`

export const FEDERATED_DELETE_RECENTLY_SEARCHED: TypedDocumentNode<
  DeleteRecentlySearchedResponse,
  DeleteRecentlySearchedVariables
> = gql`
  mutation deleteRecentlySearched($id: String!) {
    deleteRecentlySearched(id: $id)
  }
`

export const RECENT_SEARCH_REFETCH_QUERIES = [
  {
    query: FEDERATED_GET_RECENT_SEARCHES,
    variables: { page: 0, size: 3 },
  },
  {
    query: FEDERATED_GET_RECENT_SEARCHES,
    variables: { page: 0, size: 50 },
  },
]
